import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Banco from 'Interface/Bancos';
import { useRemoverBancoMutation } from 'View/Service/Default/Bancos';

interface Props {
  dados: Banco;
  acoes?: boolean;
}

const Lista = ({ dados, acoes = true }: Props): React.ReactElement => {
  const toast = useToast();
  const [removerBanco] = useRemoverBancoMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerBanco(dados).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="d-flex border-bottom align-items-center justify-content-between py-2 px-3">
      <div className="fs-4">
        <Link
          to={`/bancos/editar/${dados.id}`}
          className="text-decoration-none"
        >
          {dados.nome}
        </Link>
        <small className="text-muted fs-6 d-block">
          Gerente: {dados.gerente || 'Nenhum especificado'}
        </small>
      </div>
      <BrowserView className="d-flex align-items-center">
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.agencia}
            <small className="text-muted fs-6 d-block">
              Agência
            </small>
          </div>
        </div>
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.conta}
            <small className="text-muted fs-6 d-block">
              Conta
            </small>
          </div>
        </div>
        <div className="ms-2 fs-5 text-end">
          {acoes && (
            <Botao
              icone="trash"
              tema="danger"
              className="ms-5"
              confirmacao="Você tem certeza que deseja remover esse departamento? Essa ação é irreversivel."
              onClick={remover}
            />
          )}
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
